import type { Chapter } from '@/types'

export function normalizeContentVersion(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return Math.floor(value)
  }
  return 0
}

export function createChapterSaveId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `save-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export function appendInDoubtSaveId(existing: string[] | undefined, saveId: string): string[] {
  const next = [...(existing || []), saveId]
  if (next.length <= 10) {
    return next
  }
  return next.slice(-10)
}

export function readServerContentVersion(chapter: Chapter | null | undefined): number {
  return normalizeContentVersion((chapter as { contentVersion?: number | null })?.contentVersion)
}

export function readServerLastContentSaveId(chapter: Chapter | null | undefined): string | null {
  const value = (chapter as { lastContentSaveId?: string | null })?.lastContentSaveId
  return typeof value === 'string' && value.length > 0 ? value : null
}
